// Trampos.co color palette
export const colors = {
  // Cores principais do Trampos
  primary: '#2C3573', // indigo-800
  secondary: '#A84D9E', // purple-400
  accent: '#54c4c8', // job-color
  
  // Cores de status
  success: '#4caf50', // green-500
  warning: '#ffc107', // amber-500
  danger: '#f44336', // red-500
  error: '#f44336', // red-500
  info: '#2196f3', // blue-500
  
  // Cores de texto
  text: '#212121', // grey-900
  textLight: '#757575', // grey-600
  textMuted: '#9e9e9e', // grey-500
  
  // Cores de fundo
  background: '#fafafa', // grey-50
  white: '#ffffff',
  light: '#f5f5f5', // grey-100
  
  // Cores de borda
  border: '#e0e0e0', // grey-300
  borderLight: '#eeeeee', // grey-200
  
  // Cores específicas do Trampos
  job: '#54c4c8',
  freelance: '#ed5d70',
  internship: '#e98c46',
  trainee: '#e1ce00'
};